module.exports = __webpack_public_path__ + "img/img3.ae0a72fb.jpg";